<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-right>
      <!-- <a
        class="button primary"
        *ngIf="'CreateFanClub' | hasPermission"
        [routerLink]="['./create']"
        >Approve</a> -->
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>
<vdr-data-table-2
  class="mt-2"
  id="fan-club-table"
  [items]="items$ | async"
  [itemsPerPage]="itemsPerPage$ | async"
  [totalItems]="totalItems$ | async"
  [currentPage]="currentPage$ | async"
  [filters]="filters"
  (pageChange)="setPageNumber($event)"
  (itemsPerPageChange)="setItemsPerPage($event)"
>
  <vdr-bulk-action-menu
    locationId="fan-club-page"
    [hostComponent]="this"
    [selectionManager]="selectionManager"
  ></vdr-bulk-action-menu>
  <vdr-dt2-search
    [searchTermControl]="searchTermControl"
    [searchTermPlaceholder]="'common.search-by-name' | translate"
  />
  <vdr-dt2-column
    [heading]="'common.id' | translate"
    id="id"
    [hiddenByDefault]="false"
    [sort]="sorts.get('id')"
  >
    <ng-template let-fanclub="item">
      {{ fanclub.id }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column [heading]="'common.image' | translate" id="image">
    <ng-template let-fanclub="item">
      <div class="image-placeholder">
        <img
          *ngIf="fanclub.logo as asset; else imagePlaceholder"
          [src]="asset | assetPreview : 'tiny'"
        />
        <ng-template #imagePlaceholder>
          <div class="placeholder">
            <clr-icon shape="image" size="48"></clr-icon>
          </div>
        </ng-template>
      </div>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'common.name' | translate"
    id="name"
    [hiddenByDefault]="false"
    [sort]="sorts.get('name')"
  >
    <ng-template let-fanclub="item">
      <!-- <a class="button-ghost" [routerLink]="['./', fanclub.id]"
        ><span>{{ fanclub.name }}</span
        ><clr-icon shape="arrow right"
      /></a> -->
      {{ fanclub.name }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'common.description' | translate"
    id="name"
    [hiddenByDefault]="false"
    [sort]="sorts.get('description')"
  >
    <ng-template let-fanclub="item">
      <!-- <a class="button-ghost" [routerLink]="['./', fanclub.id]"
        ><span>{{ fanclub.name }}</span
        ><clr-icon shape="arrow right"
      /></a> -->
      {{ fanclub.description }}
    </ng-template>
  </vdr-dt2-column>

  <!-- <vdr-dt2-column
    [heading]="'common.artistName' | translate"
    id="artistName"
    [hiddenByDefault]="false"
    [sort]="sorts.get('artistName')"
  >
    <ng-template let-fanclub="item">
      {{ fanclub.artist?.name }}
    </ng-template>
  </vdr-dt2-column> -->

  <vdr-dt2-column
    [heading]="'common.created-at' | translate"
    id="created-at"
    [hiddenByDefault]="false"
    [sort]="sorts.get('createdAt')"
  >
    <ng-template let-fanclub="item">
      {{ fanclub.createdAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [heading]="'common.updated-at' | translate"
    id="updated-at"
    [hiddenByDefault]="false"
    [sort]="sorts.get('updatedAt')"
  >
    <ng-template let-fanclub="item">
      {{ fanclub.updatedAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'common.artistName' | translate"
    id="artistName"
    [hiddenByDefault]="false"
  >
    <ng-template let-fanclub="item">
      {{ fanclub.artist.name }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'common.public' | translate"
    id="public"
    [hiddenByDefault]="false"
  >
    <ng-template let-fanclub="item">
      {{ fanclub.isActive }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'common.autoApprove' | translate"
    id="autodApprove"
    [hiddenByDefault]="false"
  >
    <ng-template let-fanclub="item">
      {{ fanclub.isAutoApprove }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'Submit by' | translate"
    id="submit-by"
    [hiddenByDefault]="false"
  >
    <ng-template let-fanclub="item">
      {{ fanclub.createdBy.identifier }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [heading]="'common.action' | translate"
    id="action"
    [hiddenByDefault]="false"
  >
    <ng-template let-auditRequest="item">
      <div style="display: flex">
        <button
          type="button"
          class="btn btn-primary"
          (click)="approve(auditRequest)"
        >
          {{ "common.approve" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-danger"
          style="margin-left: 1rem"
          (click)="reject(auditRequest)"
        >
          {{ "common.reject" | translate }}
        </button>
      </div>
    </ng-template>
  </vdr-dt2-column>
</vdr-data-table-2>
